<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术管理</el-breadcrumb-item>
      <el-breadcrumb-item>词库管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">条件筛选</span>
        </el-col>
      </el-row>
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item label="词库" prop="cWord">
              <el-input
                v-model="queryForm.cWord"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="searchFn()"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col :span="5">
          <span class="title_class">词库管理</span>
        </el-col>
        <el-col :span="19" style="text-align: right;">
          <el-button type="primary" plain @click="importChineseWordExcelDialogVisible = true" icon="el-icon-upload2">批量导入</el-button>
          <el-button type="primary" plain @click="downloadFn" icon="el-icon-download">批量导出</el-button>
          <el-button type="primary" @click="addFn">新增词库</el-button>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="词库" prop="">小中组词库</el-table-column>
        <el-table-column label="适用年级" prop="">3年级</el-table-column>
        <el-table-column label="比赛类型" prop="">个人赛</el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              size="mini"
              @click="editDistrictMessage(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              size="small"
              style="color: #f56c6c"
              @click="deleteDialog(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <wordGroupAdd :show="editVisible" :title="editTitle" @close="closeFn"></wordGroupAdd>
  </div>
</template>
<script>
import wordGroupAdd from './components/add_word_group.vue'
export default {
  components: {
    wordGroupAdd
  },
  data () {
    return {
      dataList: [1],
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 10
      },
      editVisible: false,
      editTitle: ''
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getChineseWordList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getChineseWordList()
    },
    downloadFn () {

    },
    searchFn () {

    },
    reset () {

    },
    addFn () {
      this.editTitle = '新增词库'
      this.editVisible = true
    },
    closeFn () {
      this.editVisible = false
    }
  }
}
</script>
